var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsFloodSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_4564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1684 7.16235C32.8368 3.83076 28.4054 2 23.6959 2C18.98 2 14.5551 3.83076 11.2235 7.16235C7.89191 10.4939 6.05469 14.9253 6.05469 19.6348C6.05469 29.1638 15.0662 37.0949 19.9115 41.3516C20.5843 41.9467 21.1601 42.4578 21.6258 42.8848C22.208 43.4282 22.952 43.6999 23.6959 43.6999C24.4399 43.6999 25.1838 43.4282 25.7596 42.8848C26.2254 42.4578 26.8076 41.9467 27.4804 41.3516C32.3193 37.0949 41.3307 29.1638 41.3307 19.6348C41.3307 14.9253 39.5 10.4939 36.1684 7.16235Z",
    fill: "#E13827",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0624 12.3716L27.6223 12.4302L27.7638 13.4922L28.2038 13.4336C28.7389 13.3626 29.2917 13.5096 29.7205 13.8376C30.1495 14.1658 30.4359 14.6607 30.5074 15.1957L30.5661 15.6358L31.628 15.4943L31.5694 15.0543C31.4609 14.2393 31.0242 13.4859 30.3713 12.9865C29.7188 12.4873 28.8773 12.2631 28.0624 12.3716Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8189 15.3372L33.8806 15.1943L33.8631 15.0663C33.6618 13.5543 32.8845 12.2118 31.673 11.2851C30.4616 10.3584 28.9626 9.95923 27.4513 10.1608L27.3225 10.1777L27.4625 11.2398L27.592 11.223C28.82 11.0594 30.0384 11.3837 31.0222 12.1362C32.006 12.8887 32.6382 13.9794 32.8015 15.2084L32.8189 15.3372Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8562 8.97393C29.4619 8.93892 31.0486 9.45708 32.3245 10.433C33.6001 11.4088 34.5156 12.8046 34.9022 14.3637L35.0832 15.0931L36.1235 14.8353L35.9423 14.1057C35.4978 12.3114 34.4438 10.7044 32.9757 9.5814C31.5076 8.45866 29.6805 7.8623 27.8328 7.90241L27.0808 7.91896L27.1043 8.99048L27.8562 8.97393Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6861 14.373C18.9597 14.373 15.1143 18.2186 15.1143 22.9449C15.1143 27.6713 18.9598 31.5168 23.6861 31.5168C28.4125 31.5168 32.258 27.6712 32.258 22.9449C32.258 18.2185 28.4124 14.373 23.6861 14.373ZM22.0788 29.374H21.0074V28.3026H22.0788V29.374ZM24.2219 29.374H23.1504V28.3026H24.2219V29.374ZM26.3649 29.374H25.2935V28.3026H26.3649V29.374ZM23.8665 26.6952H23.5049C22.1255 26.6952 21.0067 25.5765 21.0067 24.197C21.0067 23.7287 21.1386 23.2702 21.3865 22.8733L23.6855 19.1949L25.9844 22.8733C26.2324 23.2702 26.3642 23.7289 26.3642 24.197C26.3649 25.5767 25.2462 26.6952 23.8665 26.6952ZM27.7337 29.284L27.1396 28.3925C29.0035 27.1501 30.1157 25.0713 30.1157 22.8318C30.1157 19.3489 27.2827 16.5158 23.7997 16.5158H23.5737C20.0907 16.5158 17.2577 19.3488 17.2577 22.8318C17.2577 25.0714 18.3699 27.1499 20.2338 28.3925L19.6383 29.284C17.476 27.8428 16.1855 25.4304 16.1855 22.8319C16.1855 18.758 19.4995 15.4445 23.5729 15.4445H23.7989C27.8728 15.4445 31.1863 18.7585 31.1863 22.8319C31.1866 25.4297 29.896 27.8422 27.7337 29.284H27.7337Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_4564",
    x: 0.554688,
    y: 0.5,
    width: 46.2759,
    height: 52.6997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_4564"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_4564",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsFloodSensor);
export default __webpack_public_path__ + "static/media/alertsFloodSensor.8de5ce0a8e7cd265dfd208c727f59b9f.svg";
export { ForwardRef as ReactComponent };